<template>
	<div>
		<h2>Trends List</h2>
		<div class="dynvibeBox">
			<div class="col-lg-12">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="Object.keys(this.trends).length > 0">
					<div class="row">
						<div class="right">
							<perpagesort :size="true" :sortable="false" @changerange="changeRangePage"></perpagesort>
						</div>
					</div>
					<div class="row">
						<div class="right">
							<input class="searchInput" type="text" placeholder="Search trend" v-model="searchTrends" />
						</div>
					</div>
					<table class="table dynvibeTable">
						<thead>
							<tr>
								<th class="col-xs-3 sortable" v-on:click="columnOrderBy('label')">Trend</th>
								<th class="col-xs-4">Mastertags</th>
								<th class="col-xs-2 sortable" v-on:click="columnOrderBy('@timestamp')">Creation Date</th>
								<th v-if="toggleDeactivated" v-on:click="columnOrderBy('deactivation_date')" class="col-xs-2 sortable">
									Deactivation Date
								</th>
								<th v-else class="col-xs-2">&nbsp;</th>
								<th class="col-xs-1">Activated ?</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="trend in this.shownTrends"
								:key="trend['_id']"
								:class="{
									hidden: !this.toggleDeactivated && isDeactivated(trend),
								}"
							>
								<td class="col-xs-3">
									{{ trend["label"] }}
								</td>
								<td class="col-xs-4">
									<div class="dynvibeRuleTag" v-for="mastertag in trend['mastertags']" :key="trend + '_' + mastertag">
										{{ mastertag }}
									</div>
								</td>
								<td class="col-xs-2">
									{{ formatDate(trend["@timestamp"]) }}
								</td>
								<td class="col-xs-2" v-if="isDeactivated(trend)">
									{{ formatDate(trend["deactivation_date"]) }}
								</td>
								<td class="col-xs-2" v-else>&nbsp;</td>
								<td class="col-xs-1">
									<div v-if="isDeactivated(trend)">
										<span @click="activate(trend)"> <i class="fas fa-eye"> </i></span>
									</div>
									<div v-else>
										<span @click="deactivate(trend)"><i class="fas fa-eye visible"></i></span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="row pagination">
						<div class="col-lg-12">
							<div style="float: right; margin-top: 10px">
								<pagination v-if="page >= 0" :page="page" :page-max="pageMax" @changepage="changePage($event)"></pagination>
							</div>
						</div>
					</div>
					<div class="row dynvibeRow">
						<div class="col-md-6">
							<span class="toggle-label">Display deactivated trends</span>
						</div>
						<div class="col-md-3">
							<span v-if="toggleDeactivated" @click="changeToggle">
								<i class="fa toggle fa-toggle-on"></i>
							</span>
							<span v-else @click="changeToggle">
								<i class="fa toggle fa-toggle-off"></i>
							</span>
						</div>
					</div>
				</div>
				<div v-else class="noData">
					<p>No Data to display</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from "@/components/globalVue/Pagination.vue";
import perpagesort from "@/components/globalVue/perpageSort.vue";

export default {
	name: "TrendsList",
	props: {},
	data() {
		return {
			loading: false,
			trends: {},
			shownTrends: {},
			toggleDeactivated: false,
			page: 0,
			size: 20,
			pageMax: 50,
			searchTrends: "",
			columnSortId: "label",
			ascOrder: true,
		};
	},
	components: {
		pagination: pagination,
		perpagesort: perpagesort,
	},
	methods: {
		loadComponent() {
			this.loading = true;
			this.getData("getListTrends");
		},

		treatResponse(response) {
			this.loading = false;
			this.trends = response.data.data;
			this.page = 0;
			//this.pageMax = Math.round(this.trends.length / this.size);
			this.showingTrends();
		},
		formatDate(date) {
			return this.$moment(date).format("YYYY-MM-DD");
		},
		isDeactivated(trend) {
			return "deactivation_date" in trend;
		},
		showingTrends() {
			if (this.toggleDeactivated) {
				this.shownTrends = this.trends.filter((trend) => trend);
			} else {
				this.shownTrends = this.trends.filter((trend) => !("deactivation_date" in trend));
			}
			if (this.searchTrends !== "") {
				this.shownTrends = this.shownTrends.filter(
					(trend) => trend["label"].toLowerCase().indexOf(this.searchTrends.toLowerCase()) !== -1
				);
			}

			this.pageMax = Math.round(this.shownTrends.length / this.size);
			this.pageMax = this.pageMax > 0 ? this.pageMax - 1 : this.pageMax;

			this.shownTrends = this.shownTrends.slice(this.page * this.size, this.page * this.size + this.size);
		},
		changeToggle() {
			this.toggleDeactivated = !this.toggleDeactivated;
			this.showingTrends();
		},

		activate(trend) {
			let params = { id: trend["_id"] };

			this.$axios.post(this.$backendUrl + "activateTrend", this.$Qs.stringify(params)).then((response) => {
				this.trends = response.data.trends;
				this.showingTrends();
			});
		},
		deactivate(trend) {
			let params = { id: trend["_id"] };

			this.$axios.post(this.$backendUrl + "deactivateTrend", this.$Qs.stringify(params)).then((response) => {
				this.trends = response.data.trends;
				this.showingTrends();
			});
		},
		changeRangePage(range) {
			this.page = 0;
			this.size = range;
			if (this.size === "") {
				this.size = 20;
			}
			//this.pageMax = Math.round(this.trends.length / this.size);
			this.showingTrends();
		},
		changePage(page) {
			this.page = page;
			this.showingTrends();
		},
		columnOrderBy(columnId) {
			if (this.columnSortId === columnId) {
				this.ascOrder = !this.ascOrder;
			} else {
				this.ascOrder = true;
			}

			if (this.ascOrder) {
				// ASC
				this.trends = this.trends.sort(function (a, b) {
					if (!a[columnId]) {
						return 1;
					}
					if (!b[columnId]) {
						return -1;
					}
					if (columnId === "label") {
						// case insensitive
						return a[columnId].toLowerCase().localeCompare(b[columnId].toLowerCase());
					}

					return a[columnId] > b[columnId] ? 1 : -1;
				});
			} else {
				this.trends = this.trends.sort(function (a, b) {
					if (!a[columnId]) {
						return 1;
					}
					if (!b[columnId]) {
						return -1;
					}
					if (columnId === "label") {
						// case insensitive
						return b[columnId].toLowerCase().localeCompare(a[columnId].toLowerCase());
					}
					return a[columnId] < b[columnId] ? 1 : -1;
				});
			}

			this.columnSortId = columnId;
			this.showingTrends();
		},
	},
	watch: {
		searchTrends() {
			this.page = 0;
			this.showingTrends();
		},
	},
};
</script>

<style>
.dynvibeTable tbody {
	height: auto;
}
.dynvibeTable > thead > tr,
.dynvibeTable > tbody > tr {
	display: flow-root;
}

table.dynvibeTable tr th.sortable {
	cursor: pointer;
}

.fa-eye {
	font-size: 16px;
}

.fa-eye.visible {
	color: #46b132;
}

.hidden {
	display: none;
}

.toggle {
	font-size: 20px;
	cursor: pointer;
	color: #46b132;
}

.toggle-label {
	font-weight: 400 !important;
	font-size: 14px;
	font-family: "Montserrat";
}

.dynvibeRuleTag {
	cursor: default;
}

.searchInput {
	height: 31px;
	min-width: 300px;
	border-radius: 12px;
	border: 1px solid #cacaca;
	color: #8e8e8e;
}

.searchInput:focus,
.searchInput:focus-visible {
	outline: none;
}

.dynvibeSelect {
	min-width: 300px;
}
.right {
	float: right;
	margin-top: 10px;
	margin-right: 20px;
}

.dynvibeRuleTag {
	min-width: auto;
	padding-left: 7px;
	padding-right: 7px;
}
</style>
